<!-- First time code goes in here, ng-template vil not run before they are called -->
@if (catalogTree) {
  <ng-container *ngTemplateOutlet="treeTemplate; context: { $implicit: catalogTree, role: 'tree', parentid: 'root' }" />
}

<ng-template #treeTemplate let-nodes let-role="role" let-parentid="parentid">
  <ul [attr.role]="role" tabindex="-1">
    @for (item of nodes; track item; let i = $index) {
      <li
        [id]="item.id + item.label"
        [ngClass]="{
          'border-layer-level': item.category === 'layer',
          li: !item.firstLevel,
          'li-first-level': item.firstLevel,
        }"
        draggable="false"
        role="treeitem"
        tabindex="0">
        <ng-container *ngTemplateOutlet="nodeTemplate; context: { $implicit: item }"> </ng-container>
        @if (item.children && item.children.length > 0 && item.expanded) {
          <ng-container
            *ngTemplateOutlet="
              treeTemplate;
              context: {
                $implicit: item.children,
                role: 'group',
                parentid: item.id + item.label,
              }
            ">
          </ng-container>
        }
      </li>
    }
  </ul>
</ng-template>
